import api from "../axios";


/*
|--------------------------------------------------------------------------
| LIST OFFERING IMAGES
|--------------------------------------------------------------------------
|
| GET /api/offering-images/offering/:offeringId
|
*/

export const getOfferingImagesApi = async (
  offeringId
) => {

  return api.get(
    `/offering-images/offering/${offeringId}`
  );

};


/*
|--------------------------------------------------------------------------
| GET SINGLE OFFERING IMAGE
|--------------------------------------------------------------------------
|
| GET /api/offering-images/:id
|
*/

export const getOfferingImageApi = async (
  id
) => {

  return api.get(
    `/offering-images/${id}`
  );

};


/*
|--------------------------------------------------------------------------
| CREATE OFFERING IMAGE
|--------------------------------------------------------------------------
|
| POST /api/offering-images/offering/:offeringId
|
| multipart/form-data
|
*/

export const createOfferingImageApi = async (
  offeringId,
  formData
) => {

  return api.post(
    `/offering-images/offering/${offeringId}`,
    formData
  );

};


/*
|--------------------------------------------------------------------------
| UPDATE OFFERING IMAGE
|--------------------------------------------------------------------------
|
| PATCH /api/offering-images/:id
|
*/

export const updateOfferingImageApi = async (
  id,
  data
) => {

  return api.patch(
    `/offering-images/${id}`,
    data
  );

};


/*
|--------------------------------------------------------------------------
| DELETE OFFERING IMAGE
|--------------------------------------------------------------------------
|
| DELETE /api/offering-images/:id
|
*/

export const deleteOfferingImageApi = async (
  id
) => {

  return api.delete(
    `/offering-images/${id}`
  );

};